import { render, staticRenderFns } from "./PropositionsPhone.vue?vue&type=template&id=7d9b7c2a&scoped=true&"
import script from "./PropositionsPhone.vue?vue&type=script&lang=js&"
export * from "./PropositionsPhone.vue?vue&type=script&lang=js&"
import style1 from "./PropositionsPhone.vue?vue&type=style&index=1&id=7d9b7c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9b7c2a",
  null
  
)

export default component.exports